export const PRIVATE_ACCOUNT_NAME = 'Private account'

/**
 * Checks if a comment is from a private LinkedIn account
 * @param args.serviceType - The service type of the channel present also in the comment object
 * @param args.comment - The comment data (only its author name is read)
 * @returns true if the comment is from a private LinkedIn account
 */
export const isPrivateLinkedInAccount = (args: {
  serviceType: string
  comment: { author: { name?: string | null } }
}): boolean => {
  const { serviceType, comment } = args
  return (
    serviceType === 'linkedin' && comment.author.name === PRIVATE_ACCOUNT_NAME
  )
}
